/*
  ヘッダー上部のバナースライド
*/

document.addEventListener('DOMContentLoaded', function() {
  const initializeSwiper = () => {
    const heroGalleryModalSwiper = new Swiper('[data-collection-banner].swiper', {
      centeredSlides :false,
      direction: "horizontal",
      loop: false,
      pagination: {
        el: '[data-collection-banner] .swiper-pagination',
        clickable: true,
      },
      navigation : {
        nextEl: '[data-collection-banner] .swiper-button-next',
        prevEl: '[data-collection-banner] .swiper-button-prev',
      },
      keyboard : {
        enabled: true,
      },
      slidesPerView: 1.3,
      spaceBetween: 20,
      breakpoints: {
        578: {
          slidesPerView:2.3
        },
        768: {
          slidesPerView:2.5
        },
        1025: {
          slidesPerView:2.9
        },
        1240: {
          slidesPerView:3.2
        },
        1441: {
          slidesPerView:3.5
        }

      }
    });
  }

  initializeSwiper();

  window.addEventListener('resize', () => {
    initializeSwiper();
  });
  document.addEventListener("shopify:section:load",() => {
    initializeSwiper();
  });
});